import { render } from "./HorizontalScroll.vue?vue&type=template&id=0f25b24b"
import script from "./HorizontalScroll.vue?vue&type=script&lang=js"
export * from "./HorizontalScroll.vue?vue&type=script&lang=js"

import "./HorizontalScroll.vue?vue&type=style&index=0&id=0f25b24b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__